export const APP_CONFIG = {
  //apiServer: "https://testapi.apptoin.com",
  apiServer: "https://api2.apptoin.com",
  //apiServer: "https://apptoin.com/api_v1",
  //apiServer: "https://aquapium.com/api_v1",
  //apiServer: "http://192.168.0.26/apitoin",
  //apiServer: "http://localhost/apitoin/web",
  //apiServer: "https://192.168.43.188/apitoin/web"
  debugMode: true,
  log: function(...args: any[]) {
    if (this.debugMode) {
      //console.log("ATILog:", ...args);
      
      console.log("ATILog:");
      for (let i = 0; i < args.length; i++) {
        const element = args[i];
        // console.log( JSON.stringify(element));
        console.log(element);
          
      }
      
    }
  },
  error: function(...args: any[]) {
    if (this.debugMode) {
      console.error(...args);
    }
  },
  getErrores(translateService, errorCodes: string[]) {
    var arErrores: { [id: string]: string } = {};
    errorCodes.forEach(el => {
      translateService.get(el).subscribe(value => {
        (
        arErrores[el] = value
        
        );
      
        //this.log(el, value);
      });
    })
    return arErrores;
  },
  firstRun: true
};



// WEBPACK FOOTER //
// ./src/app/app.config.ts